import keycloak from '../keycloak-client';

function RequireAuth({ children }: { children: JSX.Element }) {
  if (!keycloak.authenticated) {
    return <div>Redirecting to login...</div>;
  }

  return children;
}

export default RequireAuth;
